import React from 'react';
import PropTypes from 'prop-types';
import { Inline } from '../LayoutPrimitives';
import { PlaceholderText } from '../Placeholder';
import Breadcrumbs from '../Breadcrumbs';

const propTypes = {
    path: PropTypes.arrayOf(PropTypes.shape({})),
    isLoading: PropTypes.bool
};

const BreadcrumbsContainer = ({ path, isLoading }) => {
    if (isLoading) {
        return (
            <Inline className="rec-breadcrumb-wrap">
                <PlaceholderText fontSize={20} lineHeight={23} width="150px" />
                <span> / </span>
                <PlaceholderText fontSize={20} lineHeight={23} width="150px" />
                <span> / </span>
                <PlaceholderText fontSize={20} lineHeight={23} width="150px" />
            </Inline>
        )
    }

    return (path && path.length > 0) && (
        <div className="rec-breadcrumb-wrap">
            <Breadcrumbs path={path} />
        </div>
    )
}

BreadcrumbsContainer.propTypes = propTypes;

export default BreadcrumbsContainer;